<template>
  <el-popover
    ref="popver-download"
    v-model="show"
    placement="bottom"
    trigger="click"
    @show="onShowEvent"
    @hide="onHideEvent"
  >
    <div slot="reference" class="nav-downloads-wrapper">
      <svg-icon class-name="nav-file-download" icon-class="download" />
      <span style="margin-right:5px;">Downloads</span>

      <i class="el-icon-caret-bottom icon-arrow-down" style="margin-left:5px;" />
    </div>
    <div v-if="list<=0">
      <div>
        <!-- <img src="@/assets/img/download_empty.png" style="width: 60px;" alt="">
        <div class="empty-tip">
          You have no downloads yet
        </div> -->
      </div>
    </div>
    <div v-else class="download-list-container">
      <div
        v-for="(item,index) in list"
        :key="item.name"
        class="nav-download-item"
        :class="{
          'border-1': index !== (list.length-1),
          'padding-top-0': index === 0,
          'padding-bottom-0': index === (list.length-1),
        }"
      >
        <div>
          <div class="nav-download-name text-12-600">{{ item.task_name }}</div>
          <div v-if="item.create_time" class="nav-download-time">{{ item.create_time }}</div>
          <div class="nav-download-status text-12-400"><span>Status: </span>
            <span v-show="item.task_status === PENDING" v-loading class="color-1d3a41">
              Downloading<div class="loading-dots">
                <div class="dot" />
                <div class="dot" />
                <div class="dot" />
              </div>
            </span>
            <span v-show="item.task_status === SUCCESS" class="color-blue">Ready to Download</span>
            <span v-show="[FAIL,INITFAIL].includes(item.task_status)" class="color-aaa">Failed</span>
          </div>
        </div>
        <div class="nav-download-icon-container">
          <el-button v-if="item.task_status === SUCCESS" type="primary" class="filter-btn-add" size="small" @click="onClickDownLoad(item)"> <svg-icon icon-class="download" /> {{ $t('components.download') }}</el-button>
        </div>

      </div>
    </div>
  </el-popover>
</template>

<script>
import { fetchDownloadTaskList } from '@/api/layout-index/layout-index'
import { download } from '@/utils/common'
export default {
  name: 'DownloadManage',
  data() {
    this.FAIL = 3
    this.SUCCESS = 2
    this.PENDING = 1
    this.INITFAIL = 0
    return {
      list: [],
      show: false
    }
  },
  // mounted(){
  //   this.$store.watch(
  //     (state) => state.app.showDownloadList,
  //     (newValue, oldValue) => {
  //       // 处理属性变化的逻辑
  //       console.log('属性值变化：', newValue);
  //       if(newValue){
  //         setTimeout(()=>{
  //           this.show = true
  //         }, 300)

  //         // this.$set(this, 'show',true)
  //         // this.show = true
  //       }
  //     }
  //   );
  // },
  // computed:{
  //   show(){
  //     return this.$store.state.app.showDownloadList
  //   }
  // },
  watch: {
    '$store.getters.showDownloadList': {
      handler: function(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.show = true
          }, 300)
        }
      }
    }
  },
  methods: {
    onShowEvent() {
      this.getDownloadList()
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.getDownloadList()
      }, 10000)
    },
    onHideEvent() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', false)
    },
    onClickDownLoad(item) {
      if (item.task_status === this.SUCCESS) {
        download(item.file_path, '_blank')
      }
    },
    getDownloadList() {
      fetchDownloadTaskList().then(res => {
        const data = res.data || []
        this.list = data.slice(0, 10)
        const item = this.list.find(item => item.task_status === this.PENDING)
        if (!item) {
          if (this.timer) {
            clearInterval(this.timer)
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.nav-downloads-wrapper{
  display: flex;
  align-items: center;
  color: #364250;
  font-weight: 500;
  font-family: 'Inter-Medium';
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}
.nav-downloads-container{
  display: inline-block;

}
.download-list-container{
  max-height: 400px;
  overflow: auto;
  padding: 12px;
  &::-webkit-scrollbar-track-piece {
    background: #d3dce6;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #99a9bf;
    border-radius: 20px;
  }
}

.nav-file-download{
  color: #364250;
  font-size: 18px;
  margin-right: 8px;
}
.nav-download-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  font-size: 12px;
  color: #000;
}

.border-1{
  border-bottom: 1px solid rgba(54, 66, 80, 0.20);
}
.nav-download-icon-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 36px;
  .dropdown-file-download{
    font-weight: 700;
    font-size: 19px;
    color: #fff
  }
}
.nav-download-name{
  line-height: 1.5;
  width: 500px;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}
.padding-top-0{
  padding-top: 0;
}
.padding-bottom-0{
  padding-bottom: 0;
}
.nav-download-status{
  margin-top: 5px;
}
.nav-download-time{
  // margin-top: 8px;
  color: rgba(54, 66, 80, 0.50);
  font-size: 12px;
}

.empty-container{
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 280px;
  min-height: 250px;
  .empty-tip{
    margin-top: 10px;
    color: #C9C9C9;
    font-size: 15px;
  }
}

.color-blue{
  color: #488CE8;
  font-weight: bold;
}
.color-1d3a41{
  color: #488CE8;
  font-weight: bold;
}
.color-aaa{
  color: #FF332E;
  font-weight: bold;
}

.loading-dots {
  display: inline-flex;
  justify-content: center;
}

.dot {
  width: 4px;
  height: 4px;
  background-color: #488CE8;
  border-radius: 50%;
  margin: 0 5px;
  opacity: 0.4;
  animation: loading-animation 1.5s infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loading-animation {
  0% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0.4;
    transform: scale(1);
  }
}
</style>
